import { SET_CURRENT_PLAN_ID_TO_SHOW_DETAILS } from '../constants/planActionTypes';
import { AppCurrentPlanIdToShowDetailsTypeAction } from '../constants/planTypes';

export const setCurrentPlanIdToShowDetailsAction = (
  planToShowDetailsId?: number
): AppCurrentPlanIdToShowDetailsTypeAction => ({
  type: SET_CURRENT_PLAN_ID_TO_SHOW_DETAILS,
  planToShowDetailsId,
});
